import React, { useEffect, useState } from "react";
import translate from "../../reusable/translate";
import moment from "moment";
import { getCommitmentTypeId } from "../../materialCommitment/helpers/Categories";
import ProfilePicture from "../../materialCommitment/commitment/ProfilePicture";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";

import commitmentSlice from "../../../state/slices/commitmentSlice";

const CreationInfo = ({ fetchedCommitment, dateRef }) => {
  const dispatch = useDispatch();
  const { changeEndDate } = bindActionCreators(
    commitmentSlice.actions,
    dispatch
  );
  const { commitment, language } = useSelector(state => state);
  const [loading, setLoading] = useState(true);
  const [preSetEndDate, setPreSetEndDate] = useState("");

  const organization = fetchedCommitment.organizations.find(
    org => org.name === commitment.organizationName
  );

  const updateOrganizationLogo = async pic => {
    await fetch("/o/commitment2050-service/organizationapi/logo", {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
        "Cache-Control": "no-cache"
      },
      credentials: "include",
      body: JSON.stringify({
        logo: pic ? pic.split(",")[1] : null,
        organizationId: organization.organizationId
      })
    });
  };

  useEffect(() => {
    const id = getCommitmentTypeId(commitment.commitmentType);

    const fetchCategory = async () => {
      const category = await fetch(
        `/o/commitment2050-service/commitmentapi/categories/${id}`
      ).then(res => res.json());
      setPreSetEndDate(category.properties.endDate);
      if (commitment.endDate || (category && category.properties.endDate)) {
        setPreSetEndDate(category.properties.endDate);
      }
      setLoading(false);
    };
    fetchCategory();
  }, []);

  useEffect(() => {
    if (preSetEndDate) {
      changeEndDate(preSetEndDate);
    }
  }, [preSetEndDate]);

  if (loading) return null;

  return (
    <div className="flex-row border-bottom space-between">
      <div className="flex-column">
        <Row
          textKey={"sit.commitmentCreation.creator.871646"}
          text={commitment.organizationName}
          language={language}
        />

        <Row
          textKey={"sit.commitmentCreation.startingDate.871646"}
          text={
            commitment.startDate
              ? moment(commitment.startDate).format("DD.MM.YYYY")
              : new Date().toLocaleDateString("fi-FI")
          }
          language={language}
        />
        <Row
          textKey={"sit.commitmentCreation.endDate.871646"}
          text={moment(commitment.endDate || "2035-12-31").format("DD.MM.YYYY")}
          language={language}
        />
      </div>

      {organization && (
        <ProfilePicture
          profilePic={organization.logo}
          onSelect={updateOrganizationLogo}
        />
      )}
    </div>
  );
};
export default CreationInfo;

const Row = ({ textKey, text, language }) => {
  return (
    <div className="grid35">
      <b>{translate({ textKey: textKey, languageOverride: language })}</b>
      <p className="p">{text}</p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/circularEconomyCommitment/commitment/CreationInfo.jsx